type BadgeVariant = 'earned' | 'locked' | 'highlight'

interface BadgeProps {
  variant?: BadgeVariant
  emoji: string
  label: string
}

const badgeStyles: Record<BadgeVariant, string> = {
  earned: 'bg-tessan-cream text-tessan-green',
  locked: 'bg-gray-100 text-gray-400 opacity-60',
  highlight: 'bg-tessan-yellow text-tessan-green',
}

export function Badge({ variant = 'earned', emoji, label }: BadgeProps) {
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium ${badgeStyles[variant]}`}>
      <span>{emoji}</span>
      <span>{label}</span>
    </span>
  )
}
